import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import './styles.scss'
import Heading from '../heading/Heading';
import Input from '../form/inputs/Input'; 
import InputCalendar from '../form/inputs/inputCalendar';
import Textarea from './../form/inputs/Textarea';
import "moment/locale/pl";
import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";
import MomentUtils from '@date-io/moment';
import moment from 'moment';

const ReceivablesDeliveriesServices = ( props ) => {
    let [ isOpenFirst, setIsOpenFirst ]       = useState([]);   
    const dispatch                            = useDispatch()
    let receivablesObligationsDeliveriesServicesDate     = useSelector(state => state.receivablesObligationsDeliveriesServicesDate)
    let obligationsTotalPrice                 = useSelector(state => state.obligationsTotalPrice);
    let obligationsLastDatePay                = useSelector(state => state.obligationsLastDatePay);
    let obligationsNumberCreditors            = useSelector(state => state.obligationsNumberCreditors);
    let obligationsOverdueLiabilities         = useSelector(state => state.obligationsOverdueLiabilities);
    let obligationsOverdueLiabilitiesOver30Days = useSelector(state => state.obligationsOverdueLiabilitiesOver30Days);
    let receivablesTotalPrice                 = useSelector(state => state.receivablesTotalPrice);
    let receivablesLastDatePay                = useSelector(state => state.receivablesLastDatePay);
    let receivablesNumberCreditors            = useSelector(state => state.receivablesNumberCreditors);
    let receivablesOverdueLiabilities         = useSelector(state => state.receivablesOverdueLiabilities);
    let receivablesOverdueLiabilitiesOver30Days = useSelector(state => state.receivablesOverdueLiabilitiesOver30Days);
    let explanationReceivablesObligations = useSelector(state => state.explanationReceivablesObligations);
    let explanationLoss                       = useSelector(state => state.explanationLoss);
    
    const materialTheme = createMuiTheme({
        overrides: {
            MuiPickersCalendarHeader: {
                switchHeader: {
                    color: '#74726b',
                },
              },
          MuiPickersDay: {
                day: {
                    color: '#74726b',
                },
            },
        }
    });

    const updateCalendar = (index, status) => {
        let newRes = [];
        if(status) {
            if(!isOpenFirst.includes(index)) {
                setIsOpenFirst([...isOpenFirst, index]);
            }
        }else{
            if(isOpenFirst.includes(index)) {
                newRes = isOpenFirst.filter(first => first == index ? null : first)
                setIsOpenFirst(newRes);
            }
        }
    }

    return (
        <div className="receivables-deliveries-services">
            <Heading title="Zobowiązania i należności z tytułu dostaw i usług" medium />
            <div className="row">
                {/* <Heading title="Zobowiązania i należności z tytułu dostaw i usług" small /> */}
                <InputCalendar  name={"receivablesObligationsDeliveriesServicesDate"}
                                id={"receivablesObligationsDeliveriesServicesDate"}
                                required={ true }
                                setFunction={ val => dispatch({ type: 'RECEIVABLES_OBLIGATIONS_DELIVERIES_SERVICES_DATE_CHANGE', value: val }) }
                                type="text"
                                placehold={ "Stan na dzień" }
                                val={ receivablesObligationsDeliveriesServicesDate }
                                size="xxl" 
                                calendar={ true }
                                regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                allowChars={/^[0-9-]{0,10}$/}
                                minChar={ 1 } 
                                maxDate={new Date()}
                                openCalendar={ () => updateCalendar(0, true) }
                                forceValidate={ props.forceValidate } />
                <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                        <KeyboardDatePicker
                            cancelLabel="Anuluj"
                            value={ receivablesObligationsDeliveriesServicesDate }
                            placeholder="2018-10-10"
                            onChange={date =>  dispatch({ type: 'RECEIVABLES_OBLIGATIONS_DELIVERIES_SERVICES_DATE_CHANGE', value: moment(date).format("YYYY-MM-DD") }) }
                            maxDate={new Date()}
                            format="YYYY-MM-DD"
                            open={isOpenFirst.includes(0)}
                            onOpen={() => updateCalendar(0, true)}
                            onClose={() => updateCalendar(0, false)}
                        />
                    </MuiPickersUtilsProvider>
                </ThemeProvider>
            </div>
            {/* zobowiązania */}
            <div className="input-row">
                <div className="col">
                    <Input  name={"obligationsTotalPrice"}
                            id="obligationsTotalPrice"
                            required={ true }
                            setFunction={ val =>  dispatch({ type: 'OBLIGATIONS_TOTAL_PRICE_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Kwota zobowiązań ogółem" }
                            val={ obligationsTotalPrice }
                            size="xxl" 
                            formatPrice={ true }
                            regExp={/^[0-9\,\.\s]+$/}
                            allowChars={/^[0-9\,\.\s]+$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
                <div className="col">
                    <InputCalendar  name={"obligationsLastDatePay"}
                                    id={"obligationsLastDatePay"}
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'OBLIGATIONS_LAST_DATE_PAY_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Ostateczny termin zapłaty" }
                                    val={ obligationsLastDatePay }
                                    size="xxl" 
                                    calendar={ true }
                                    regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                    allowChars={/^[0-9-]{0,10}$/}
                                    minChar={ 1 } 
                                    openCalendar={ () => updateCalendar(1, true) }
                                    forceValidate={ props.forceValidate } />
                    <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                            <KeyboardDatePicker
                                cancelLabel="Anuluj"
                                value={ obligationsLastDatePay }
                                placeholder="2018-10-10"
                                onChange={date =>  dispatch({ type: 'OBLIGATIONS_LAST_DATE_PAY_CHANGE', value: moment(date).format("YYYY-MM-DD") }) }
                                // maxDate={new Date()}
                                format="YYYY-MM-DD"
                                open={isOpenFirst.includes(1)}
                                onOpen={() => updateCalendar(1, true)}
                                onClose={() => updateCalendar(1, false)}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </div>
                <div className="col">
                    <Input  name="obligationsNumberCreditors"
                            id="obligationsNumberCreditors"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'OBLIGATIONS_NUMBER_CREDITORS_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Liczba wierzycieli" }
                            val={ obligationsNumberCreditors }
                            size="xxl" 
                            regExp={/^[0-9]*$/}
                            allowChars={/^[0-9]*$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
            </div>
            <div className="input-row">
                <div className="col">
                    <Input  name={"obligationsOverdueLiabilities"}
                            id="obligationsOverdueLiabilities"
                            required={ true }
                            setFunction={ val =>  dispatch({ type: 'OBLIGATIONS_OVERDUE_LIABILITIES_CHANGE', value: val }) }
                            type="text"
                            placehold={ "W tym zobowiązania przeterminowane" }
                            val={ obligationsOverdueLiabilities }
                            size="xxl" 
                            formatPrice={ true }
                            regExp={/^[0-9\,\.\s]+$/}
                            allowChars={/^[0-9\,\.\s]+$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
                <div className="col">
                    <Input  name="obligationsOverdueLiabilitiesOver30Days"
                            id="obligationsOverdueLiabilitiesOver30Days"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'OBLIGATIONS_OVERDUE_LIABILITIES_OVER_30_DAYS_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Zobowiązania przeterminowane > 30 dni" }
                            val={ obligationsOverdueLiabilitiesOver30Days }
                            size="xxl" 
                            formatPrice={ true }
                            regExp={/^[0-9\,\.\s]+$/}
                            allowChars={/^[0-9\,\.\s]+$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
            </div>
            {/* należności */}
            <div className="input-row">
                <div className="col">
                    <Input  name={"receivablesTotalPrice"}
                            id="receivablesTotalPrice"
                            required={ true }
                            setFunction={ val =>  dispatch({ type: 'RECEIVABLES_TOTAL_PRICE_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Kwota należności ogółem" }
                            val={ receivablesTotalPrice }
                            size="xxl" 
                            formatPrice={ true }
                            regExp={/^[0-9\,\.\s]+$/}
                            allowChars={/^[0-9\,\.\s]+$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
                <div className="col">
                    <InputCalendar  name={"receivablesLastDatePay"}
                                    id={"receivablesLastDatePay"}
                                    required={ true }
                                    setFunction={ val => dispatch({ type: 'RECEIVABLES_LAST_DATE_PAY_CHANGE', value: val }) }
                                    type="text"
                                    placehold={ "Ostateczny termin zapłaty" }
                                    val={ receivablesLastDatePay }
                                    size="xxl" 
                                    calendar={ true }
                                    regExp={/([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/}
                                    allowChars={/^[0-9-]{0,10}$/}
                                    minChar={ 1 } 
                                    openCalendar={ () => updateCalendar(2, true) }
                                    forceValidate={ props.forceValidate } />
                    <ThemeProvider theme={materialTheme}>
                        <MuiPickersUtilsProvider utils={MomentUtils} locale="pl">
                            <KeyboardDatePicker
                                cancelLabel="Anuluj"
                                value={ receivablesLastDatePay }
                                placeholder="2018-10-10"
                                onChange={date =>  dispatch({ type: 'RECEIVABLES_LAST_DATE_PAY_CHANGE', value: moment(date).format("YYYY-MM-DD") }) }
                                // maxDate={new Date()}
                                format="YYYY-MM-DD"
                                open={isOpenFirst.includes(2)}
                                onOpen={() => updateCalendar(2, true)}
                                onClose={() => updateCalendar(2, false)}
                            />
                        </MuiPickersUtilsProvider>
                    </ThemeProvider>
                </div>
                <div className="col">
                    <Input  name="receivablesNumberCreditors"
                            id="receivablesNumberCreditors"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'RECEIVABLES_NUMBER_CREDITORS_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Liczba dłużników" }
                            val={ receivablesNumberCreditors }
                            size="xxl" 
                            regExp={/^[0-9]*$/}
                            allowChars={/^[0-9]*$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
            </div>
            <div className="input-row">
                <div className="col">
                    <Input  name={"receivablesOverdueLiabilities"}
                            id="receivablesOverdueLiabilities"
                            required={ true }
                            setFunction={ val =>  dispatch({ type: 'RECEIVABLES_OVERDUE_LIABILITIES_CHANGE', value: val }) }
                            type="text"
                            placehold={ "W tym należności przeterminowane" }
                            val={ receivablesOverdueLiabilities }
                            size="xxl" 
                            formatPrice={ true }
                            regExp={/^[0-9\,\.\s]+$/}
                            allowChars={/^[0-9\,\.\s]+$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
                <div className="col">
                    <Input  name="receivablesOverdueLiabilitiesOver30Days"
                            id="receivablesOverdueLiabilitiesOver30Days"
                            required={ true }
                            setFunction={ val => dispatch({ type: 'RECEIVABLES_OVERDUE_LIABILITIES_OVER_30_DAYS_CHANGE', value: val }) }
                            type="text"
                            placehold={ "Należności przeterminowane > 30 dni" }
                            val={ receivablesOverdueLiabilitiesOver30Days }
                            size="xxl" 
                            formatPrice={ true }
                            regExp={/^[0-9\,\.\s]+$/}
                            allowChars={/^[0-9\,\.\s]+$/}
                            minChar={ 0 } 
                            forceValidate={ props.forceValidate } />
                </div>
            </div>
            <div className="row">
                <Heading title="Wyjaśnienie zobowiązań i należności przeterminowanych" small />
                <Textarea   required={ false }
                            id="explanationReceivablesObligations"
                            setFunction={ val => dispatch({ type: 'EXPLANATION_RECEIVABLES_OBLIGATIONS', value: val }) }
                            type="text"
                            placehold={ "Wyjaśnienie" }
                            val={ explanationReceivablesObligations }
                            size="full" 
                            minChar={ 0 }
                            small={true}
                            maxChar={ 500 } 
                            regExp={/^.{0,500}$/}
                            allowChars={/^.{0,500}$/}
                            forceValidate={ props.forceValidate } />
            </div>
            <div className="row">
                <Heading title="Wyjaśnienie straty (jeśli występowała w ostatnich 2 latach)" small />
                <Textarea   required={ false }
                            id="explanationLoss"
                            setFunction={ val => dispatch({ type: 'EXPLANATION_LOSS', value: val }) }
                            type="text"
                            placehold={ "Wyjaśnienie" }
                            val={ explanationLoss }
                            size="full" 
                            minChar={ 0 }
                            small={true}
                            maxChar={ 500 } 
                            regExp={/^.{0,500}$/}
                            allowChars={/^.{0,500}$/}
                            forceValidate={ props.forceValidate } />
            </div>
        </div>
    )
}

export default ReceivablesDeliveriesServices;